import { render, staticRenderFns } from "./VBootstrapFormGroup.vue?vue&type=template&id=64fae979&scoped=true&"
import script from "./VBootstrapFormGroup.vue?vue&type=script&lang=js&"
export * from "./VBootstrapFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./VBootstrapFormGroup.vue?vue&type=style&index=0&id=64fae979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fae979",
  null
  
)

export default component.exports